import * as Sentry from '@sentry/browser';

Sentry.init({
  dsn: 'https://038c435d3f5f277d9dde63d11db5104c@o4511055773040640.ingest.us.sentry.io/4511055877701632',
  environment: process.env.RAILS_ENV,
  enabled: process.env.RAILS_ENV === 'production',
});
